import { useContext } from "react";
import { ProjectContext } from "../../context/Project/ProjectContext";

export const useProjects = () => useContext(ProjectContext);

